import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { api } from '../services/api';

interface ShopInfo {
  shopId: string;
  shopName: string;
  location: string;
}

function BellIcon() {
  return (
    <svg
      className="h-10 w-10 text-[#6366F1]"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
    >
      <path d="M12 22a2 2 0 001.995-1.85L14 20H10a2 2 0 001.995 1.85L12 22zM12 2a7 7 0 016.996 6.76L19 9v5l2 3v1H3v-1l2-3V9a7 7 0 017-7z" />
    </svg>
  );
}

function Spinner() {
  return (
    <svg
      className="h-8 w-8 animate-spin text-[#6366F1]"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
      />
    </svg>
  );
}

export default function QRResolvePage() {
  const { token } = useParams<{ token: string }>();
  const navigate = useNavigate();
  const [error, setError] = useState('');

  useEffect(() => {
    if (!token) {
      setError('This QR code is not valid or has expired.');
      return;
    }

    let cancelled = false;

    api
      .get<ShopInfo>(`/api/v1/qr/resolve/${token}`)
      .then((shop) => {
        if (cancelled) return;
        const params = new URLSearchParams({
          name: shop.shopName,
          location: shop.location,
        });
        void navigate(`/shop/checkin/${shop.shopId}?${params.toString()}`, { replace: true });
      })
      .catch(() => {
        if (!cancelled) {
          setError('This QR code is not valid or has expired.');
        }
      });

    return () => {
      cancelled = true;
    };
  }, [token, navigate]);

  if (error) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center bg-[#F8FAFC] px-4 text-center">
        <BellIcon />
        <p className="mt-4 text-base font-medium text-[#0F172A]">{error}</p>
        <p className="mt-1 text-sm text-[#64748B]">
          Please ask the shop to provide a new QR code.
        </p>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-[#F8FAFC]">
      <Spinner />
      <p className="text-sm text-[#64748B]">Loading shop info…</p>
    </div>
  );
}
